import React from "react";
import StatusBadge from "./StatusBadge";
import { formatDateTime, formatNumber, formatPercent } from "../utils/formatters";

export default function ExecutionHistoryPanel({ history }) {
  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Histórico de execuções</h3>
        <span className="swb-subtle">{(history || []).length} registro(s)</span>
      </div>

      <div className="swb-list">
        {(history || []).length ? (
          history.map((item) => (
            <div key={item.id} className="swb-list-item">
              <div className="swb-list-item__content">
                <strong>{item.scenarioName}</strong>
                <span>
                  {formatDateTime(item.timestamp)} · {item.period}
                </span>
                <span>
                  Atendimento {formatPercent(item.attendancePct, 1)} · Gap {formatNumber(item.gap, 1)}
                </span>
              </div>
              <StatusBadge status={item.status} />
            </div>
          ))
        ) : (
          <div className="swb-empty">Nenhuma execução registrada ainda.</div>
        )}
      </div>
    </section>
  );
}
